import { AppDispatch } from '../store/store';
import { addMessage } from '../redux/infoMessageSlice';

export const getUsersWithinMunicipality = async (
  auth: string,
  dispatch: AppDispatch
) => {
  const { REACT_APP_API_URL } = process.env;
  try {
    const response = await fetch(
      `${REACT_APP_API_URL}/api/municipialityUsers/`,
      {
        method: 'GET',
        headers: {
          Authorization: auth,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      dispatch(
        addMessage({
          message: 'error.failedToFetch',
          error: 'Municipality Not Found',
        })
      );
    }
  } catch (error) {
    dispatch(
      addMessage({
        message: 'error.failedToFetch',
        error: (error as Error).name,
      })
    );
  }
};
